import axios from "axios";
import Cookies from 'js-cookie';
import {
    BASE_URL,
    API_URL,
    WEB_API_SERVICE_URL,
    LOGIN_URL,
    BASE_URL_V2,
    KMAILER_API_URL,
    REDIRECT_URL,
    CLOUD_CONTACTS_URL,
    CHATBOT_URL,
    ANALYTICS_BETA_URL,
    WMS_API_URL
} from '../base';
import { LoginInstance } from "../../src/constants"
import { ACCESS_TOKEN, REFRESH_TOKEN, redirectToLogin } from "../store/login";

import { fbCustomHeaders } from "../pages/Fallback/constants";

export enum apiBaseUrl {
    baseUrl = 'baseUrl',
    baseUrlV2 = 'baseUrlV2',
    redirectUrl = 'redirectUrl',
    apiUrl = 'apiUrl',
    webApi = 'webApi',
    parentLoginApi = 'parentLoginApi',
    kmailerApi = 'kmailerApi',
    wmsApi = 'wmsApi',
    emailApi = 'emailApi',
    cloudContactUrl = 'cloudContactUrl',
    chatbotURL = 'chatbotUrl',
    analyticsBeta = 'analyticsBeta',
}

let isRefreshing = false;
let failedQueue: { resolve: any; reject: any }[] = [];

const axiosInstance = axios.create();

// Request interceptor to add Authorization header
axiosInstance.interceptors.request.use(
	(config) => {
		const accessToken = localStorage.getItem(ACCESS_TOKEN);
		if (
			accessToken &&
			window.location.hostname !== 'localhost' &&
			config.baseURL !== apiBaseUrl.apiUrl
		) {
			config.headers['Authorization'] = `Bearer ${accessToken}`;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// Response interceptor to handle accessToken expiry errors
axiosInstance.interceptors.response.use(
	(response) => {
		return response;
	},
	async function (error) {
		const originalRequest = error.config;
		const errMsg = error.response.data.message;
		const errCode = error.response.data.code;

		// To check if the user is suspended
		if (
			errMsg === 'Your account has been suspended!' ||
			errMsg === 'User not Verified'
		) {
			redirectToLogin();
		}

		if (errCode === 'BLD2220') {
			if (isRefreshing) {
				return new Promise((resolve, reject) => {
					failedQueue.push({ resolve, reject });
				})
					.then((token) => {
						originalRequest.headers[
							'Authorization'
						] = `Bearer ${token}`;
						return axiosInstance(originalRequest);
					})
					.catch((err) => {
						return Promise.reject(err);
					});
			}

			originalRequest._retry = true;
			isRefreshing = true;

			try {
				const response = await axios.get(`${BASE_URL}rotateTokens`, {
					headers: {
						Authorization: `Bearer ${localStorage.getItem(
							REFRESH_TOKEN
						)}`,
					},
				});
				const {
					newAccessToken,
					newRefreshToken,
				} = response?.data?.data;

				// Update tokens in local storage
				localStorage.setItem(ACCESS_TOKEN, newAccessToken);
				localStorage.setItem(REFRESH_TOKEN, newRefreshToken);
				Cookies.set('refresh_token', newRefreshToken);

				originalRequest.headers[
					'Authorization'
				] = `Bearer ${newAccessToken}`;
				isRefreshing = false;

				// Process the failed requests queue
				failedQueue.forEach((prom) => prom.resolve(newAccessToken));
				failedQueue = [];

				return axiosInstance(originalRequest);
			} catch (err) {
				isRefreshing = false;
				redirectToLogin();
				return Promise.reject(err);
			}
		}

		return Promise.reject(error);
	}
);

export const networkCall = (
	type: any,
	endUrl: string,
	baseUrl: apiBaseUrl,
	includeId: boolean = true,
	header: boolean = true,
	data: any = undefined!,
	instanceId?: any,
	config?: any,
	fullResponse?: boolean,
	customHeaders?: any
) => {
    let fullUrl: string = '';
    switch (baseUrl) {
        case apiBaseUrl.baseUrl:
            fullUrl += BASE_URL;
            break;
        case apiBaseUrl.baseUrlV2:
            fullUrl += BASE_URL_V2;
            break;
        case apiBaseUrl.apiUrl:
            fullUrl += API_URL;
            break;
        case apiBaseUrl.webApi:
            fullUrl += WEB_API_SERVICE_URL;
            break;
        case apiBaseUrl.parentLoginApi:
            fullUrl += LOGIN_URL;
            break;
        case apiBaseUrl.kmailerApi:
            fullUrl += KMAILER_API_URL;
        case apiBaseUrl.wmsApi:
            fullUrl = WMS_API_URL;
            break;
        case apiBaseUrl.redirectUrl:
            fullUrl += REDIRECT_URL;
            break;
        case apiBaseUrl.cloudContactUrl:
            fullUrl += CLOUD_CONTACTS_URL;
            break;
        case apiBaseUrl.chatbotURL:
            fullUrl += CHATBOT_URL;
            break;
        case apiBaseUrl.analyticsBeta:
            fullUrl += ANALYTICS_BETA_URL;
            break;
    }
    const SID = localStorage.getItem('KLR_FE_SID');
	if (includeId && !LoginInstance.includes(instanceId)) {
		
		if (SID) {
			let lastChar = fullUrl[fullUrl.length - 1];
			if (lastChar !== '/') {
				fullUrl += '/';
			}
			fullUrl += SID;
		} else {
			console.log('SID MISSING');
		}
	}
    let newEndUrl :any= endUrl;
    if(endUrl?.includes("fallback") && !fullUrl.includes("analytics")){
        newEndUrl = endUrl.split('?')[0];
        newEndUrl += "/"
        const params=`/${SID}`
        fullUrl += params
    }
	fullUrl += newEndUrl;
   
	let headers: object = {};

	if (header) {
		const KEY = localStorage.getItem('KLR_FE_TOKEN');
		const forUserId = localStorage.getItem('for-user-id');
		if (KEY) {
			headers = {
				'api-key': KEY,
			};
		}
		if (forUserId) {
			headers = {
				'api-key': KEY,
				'for-user-id': forUserId,
			};
		}
	} else if (typeof customHeaders != 'undefined' && customHeaders != null) {
		headers = customHeaders;
	}

    const axiosRequestConfig = {
        method: type,
        url: fullUrl,
        baseURL: baseUrl,
        data: data,
        headers: headers,
        ...config,
    };

    return new Promise((res: any, rej: any) => {

        axiosInstance(axiosRequestConfig)
            .then((result: any) => {
                if (fullResponse) {
                    res(result);
                }
                res(result.data);
            })
            .catch(function (error) {
                rej(error);
            });
    });
};
